import { useContext, useMemo } from "react";
import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import InstitutionIdentityContext from "src/contexts/data/InstitutionIdentityContext";
import { createInstitutionSubMenu } from "src/routing/navigation";

const InstitutionSubMenu: React.FC = () => {
    const { data: institutionIdentity } = useContext(InstitutionIdentityContext);

    const subMenu = useMemo(() => {
        if (!institutionIdentity) {
            return null;
        }

        return createInstitutionSubMenu(institutionIdentity);
    }, [institutionIdentity]);

    if (!subMenu) {
        return null;
    }

    return <AddPageSubMenu subMenu={subMenu} />;
};

export default InstitutionSubMenu;
